export const transformDateToTime = (date: string) => {
  if (!date) return;

  const dateObj = new Date(date);

  if (!dateObj) return;

  const hrs = dateObj.getHours();
  const mins = dateObj.getMinutes();

  return `${hrs.toString().padStart(2, '0')}:${mins} ${hrs > 12 ? 'PM' : 'AM'}`;
};
